var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#1B4DF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 33.5L32.5 30C32.6833 29.8167 32.8293 29.6 32.938 29.35C33.0467 29.1 33.1007 28.8333 33.1 28.55C33.1 27.9833 32.9 27.5 32.5 27.1C32.1 26.7 31.6167 26.5 31.05 26.5C30.7333 26.5 30.421 26.5917 30.113 26.775C29.805 26.9583 29.434 27.2667 29 27.7C28.5 27.2333 28.1083 26.9167 27.825 26.75C27.5417 26.5833 27.25 26.5 26.95 26.5C26.3833 26.5 25.9 26.7 25.5 27.1C25.1 27.5 24.9 27.9833 24.9 28.55C24.9 28.8333 24.9543 29.1 25.063 29.35C25.1717 29.6 25.3173 29.8167 25.5 30L29 33.5ZM37.4 30.25L30.25 37.4C30.05 37.6 29.825 37.75 29.575 37.85C29.325 37.95 29.075 38 28.825 38C28.575 38 28.325 37.95 28.075 37.85C27.825 37.75 27.6 37.6 27.4 37.4L18.575 28.575C18.3917 28.3917 18.25 28.1793 18.15 27.938C18.05 27.6967 18 27.4423 18 27.175V20C18 19.45 18.196 18.9793 18.588 18.588C18.98 18.1967 19.4507 18.0007 20 18H27.175C27.4417 18 27.7 18.0543 27.95 18.163C28.2 18.2717 28.4167 18.4173 28.6 18.6L37.4 27.425C37.6 27.625 37.746 27.85 37.838 28.1C37.93 28.35 37.9757 28.6 37.975 28.85C37.9743 29.1 37.9287 29.346 37.838 29.588C37.7473 29.83 37.6013 30.0507 37.4 30.25ZM28.825 36L35.975 28.85L27.15 20H20V27.15L28.825 36ZM22.5 24C22.9167 24 23.271 23.8543 23.563 23.563C23.855 23.2717 24.0007 22.9173 24 22.5C23.9993 22.0827 23.8537 21.7287 23.563 21.438C23.2723 21.1473 22.918 21.0013 22.5 21C22.082 20.9987 21.728 21.1447 21.438 21.438C21.148 21.7313 21.002 22.0853 21 22.5C20.998 22.9147 21.144 23.269 21.438 23.563C21.732 23.857 22.086 24.0027 22.5 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage27);
export default __webpack_public_path__ + "static/media/image27.263df3ac4ca68f3d8f9c843019e508cc.svg";
export { ForwardRef as ReactComponent };